import { connect } from "react-redux";
import { HopDongChoDuyet } from "components/BaoCao/HopDongChoDuyet";
import { getListHopDongChoDuyet } from "actions/DanhSachHopDongChoDuyet";
import { showFormTraGop } from "actions/ThemMoiTraGop";
import { showFormTinChap } from "actions/ThemMoiTinChap";
import { showFormCamDo } from "actions/ThemMoiCamDo";
import { showModalLoaiTaiSan } from "actions/LoaiTaiSan";

const mapStateToProps = (state) => ({
  HopDongChoDuyet: state.HopDongChoDuyet,
  user: state.user,
  phanquyen: state.phanquyen,
  inthuchi: state.inthuchi,
  loaitaisan: state.loaitaisan,
});

const mapDispatchToProps = (dispatch) => ({
  getListHopDongChoDuyet: (dataSearch) =>
    dispatch(getListHopDongChoDuyet(dataSearch)),
  showFormTraGop: (data) => dispatch(showFormTraGop(data)),
  showFormTinChap: (data) => dispatch(showFormTinChap(data)),
  showFormCamDo: (data) => dispatch(showFormCamDo(data)),
  showModalLoaiTaiSan: (data) => dispatch(showModalLoaiTaiSan(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HopDongChoDuyet);
